import React, { useEffect } from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import WhatIsVatCalculator from '../components/WhatIsVatCalculator';
import FeaturesOfVatCalculator from '../components/FeaturesOfVatCalculator';
import Benefits from '../components/Benefits';
import UseCases from '../components/UseCases';
import VatRates from '../components/VatRates';
import Calculator from '../components/Calculator';
import HowItWorks from '../components/HowItWorks';
import Features from '../components/Features';
import Faq from '../components/Faq';
import Footer from '../components/Footer';
import { initSEO } from '../seo';

const Home = () => {
  useEffect(() => {
    initSEO('home');
  }, []);

  return (
    <>
      <Header />
      <Hero />
      <Calculator />
      <HowItWorks />
      <Features />
      <WhatIsVatCalculator />
      <FeaturesOfVatCalculator />
      <Benefits />
      <UseCases />
      <VatRates />
      <Faq />
      <Footer />
    </>
  );
};

export default Home;
